"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const focusScreen_1 = __importDefault(require("./focusScreen"));
const unpause = () => {
    const screen = document.getElementById("screen");
    if (screen) {
        screen.classList.remove("paused");
        const pauses = state_1.default.pauses.map((pause) => ({
            pausedAt: pause.pausedAt,
            unpausedAt: pause.unpausedAt === null ? state_1.default.currentTime : pause.unpausedAt
        }));
        state_1.default.pauses = pauses;
        (0, focusScreen_1.default)();
    }
};
exports.default = unpause;
